import styled from 'styled-components'

export type OptionRowProps = {
  $isSelected: boolean
}

export const OptionsWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

export const OptionRow = styled.div<OptionRowProps>(({ theme, $isSelected }) => ({
  '&:hover': {
    borderColor: theme.colors.blue500,
  },
  alignItems: 'center',
  backgroundColor: $isSelected ? theme.colors.blue100 : theme.colors.white,
  border: `${theme.border.size['1']} solid ${$isSelected ? theme.colors.blue500 : theme.colors.gray500}`,
  borderRadius: theme.border.radius['8'],
  cursor: 'pointer',
  display: 'flex',
  gap: theme.space['12'],
  padding: theme.space['12'],

  transition: `border-color ${theme.transition.duration.sm} ease, background-color ${theme.transition.duration.sm} ease`,
}))

export const RadioDot = styled.div<OptionRowProps>(({ theme, $isSelected }) => ({
  '&::after': {
    backgroundColor: theme.colors.blue500,
    borderRadius: theme.border.radius.circle,
    content: '""',
    display: $isSelected ? 'block' : 'none',
    height: '0.8rem',
    width: '0.8rem',
  },
  alignItems: 'center',
  border: `${theme.border.size['2']} solid ${$isSelected ? theme.colors.blue500 : theme.colors.gray800}`,
  borderRadius: theme.border.radius.circle,
  display: 'flex',
  flexShrink: 0,
  height: '1.6rem',
  justifyContent: 'center',

  width: '1.6rem',
}))

export const OptionLabel = styled.span(() => ({
  fontSize: '1.4rem',
  fontWeight: 400,
}))
